import { CorePagination } from '@/components/Pagination';
import CoreTable from '@/components/Table';
import { useCoreContext } from '@/core';
import { Typography } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { DistrictTableColumns } from '../../components/DistrictTableColumns';

export const DistrictTable = () => {
  const { loading, districtData, setValue, getValues } = useCoreContext();
  const tableColumns = DistrictTableColumns();

  return (
    <div>
      <CoreTable
        columns={tableColumns}
        dataSource={get(districtData, 'data', [])}
        tableName='Center'
        loading={loading}
      />
      <div className='flex mt-4 justify-between'>
        <Typography.Title level={3}>
          Total: {get(districtData, 'count') > 999 ? '>= 1000' : get(districtData, 'count')}
        </Typography.Title>
        <CorePagination
          total={get(districtData, 'count') ?? 0}
          defaultPageSize={10}
          showSizeChanger
          pageSizeOptions={['5', '10', '20']}
          onChange={(page, pageSize) => {
            setValue('page', page);
            setValue('limit', pageSize);
          }}
          current={getValues('page')}
        />
      </div>
    </div>
  );
};
